export interface IMenuItemBox {
  top: number;
  height: number;
}

export interface IMenuOverflow {
  /** Index of the first item that no longer fits; `null` when every item fits. */
  firstOverflowedIndex: number | null;
  /** Vertical offset at which the overflow item is rendered. */
  overflowItemTop: number;
}

export const MENU_ITEM_HEIGHT = 44;

export const NO_MENU_OVERFLOW: IMenuOverflow = { firstOverflowedIndex: null, overflowItemTop: 0 };

export function computeMenuOverflow(items: IMenuItemBox[], availableHeight: number, overflowItemHeight: number): IMenuOverflow {
  const bottom = (item: IMenuItemBox): number => item.top + item.height;

  if (items.length === 0 || bottom(items[items.length - 1]) <= availableHeight) {
    return NO_MENU_OVERFLOW;
  }

  const limit = availableHeight - overflowItemHeight;
  const firstOverflowedIndex = items.findIndex((item) => bottom(item) > limit);

  return { firstOverflowedIndex, overflowItemTop: items[firstOverflowedIndex].top };
}
